import { render, staticRenderFns } from "./StaffBankAccountEdit.vue?vue&type=template&id=222d42ab"
import script from "./StaffBankAccountEdit.vue?vue&type=script&lang=js"
export * from "./StaffBankAccountEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports